var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center"},[_c('h4',{staticClass:"flex-shrink-0 pr-4 uppercase tracking-tight text-lg  text-black font-bold"},[_vm._t("default")],2),_c('div',{staticClass:"flex-1 border-t-2 border-vectric"})])}
var staticRenderFns = []

export { render, staticRenderFns }